const countryCodes = [
  { value: '+91', label: 'IND (+91)'},
  // { value: '+255', label: 'Tanzania (+255)' },
  // { value: '+1', label: 'USA (+1)' },
  // { value: '+44', label: 'UK (+44)' }
];

export default countryCodes;

// const countryCodes = [
//   { value: "+1", label: "United States (+1)" },
//   { value: "+91", label: "India (+91)" },
//   { value: "+44", label: "United Kingdom (+44)" },
//   { value: "+61", label: "Australia (+61)" },
//   { value: "+81", label: "Japan (+81)" },
//   { value: "+49", label: "Germany (+49)" },
//   { value: "+86", label: "China (+86)" },
//   { value: "+33", label: "France (+33)" },
//   { value: "+39", label: "Italy (+39)" },
//   { value: "+7", label: "Russia (+7)" },
 
// ];

// export default countryCodes;

